import { useTheme } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
import { MenuItemProps as MuiMenuItemProps } from '@mui/material/MenuItem';
import { MuiMenuItem, MuiListItemIcon } from '../../../../../modules/material';
import Typography from '../Typography';

export interface MenuItemProps extends MuiMenuItemProps {
  subtitle?: string;
}

export default function MenuItem(props: MenuItemProps) {
  const { children: title, subtitle, selected, ...menuItemsProps } = props;

  const theme = useTheme();

  return (
    <MuiMenuItem {...menuItemsProps} selected={selected}>
      <div>
        <Typography color={theme.palette.neutral[900]}>{title}</Typography>
        {subtitle && (
          <Typography variant="smallText" color={theme.palette.neutral[600]}>
            {subtitle}
          </Typography>
        )}
      </div>
      {selected && (
        <MuiListItemIcon>
          <CheckIcon fontSize="small" />
        </MuiListItemIcon>
      )}
    </MuiMenuItem>
  );
}
